import React from 'react'
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from 'react-toastify';

export const Form = () => {
    
    const { register, handleSubmit, formState: { errors } } = useForm();

    function submitKritikSaran(data) {
        const axios = require('axios');
        axios.post(process.env.REACT_APP_SERVER_BASE_URL + '/kritik-saran', {
            nama_lengkap: data.nama_lengkap,
            email_aktif: data.email_aktif,
            no_telepon: data.no_telepon,
            topik: data.topik,
            isi: data.isi
        }).then(function (response) {
            toast.success('Kritik dan Saran Berhasil Dikirim', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }).catch(function (error) {
            if (error.response.data.message != null) {
                if (Array.isArray(error.response.data.message)) {
                    for (const key in error.response.data.message) {
                        toast.error(`${error.response.data.message[key]}`, {
                            position: "bottom-left",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                } else {
                    toast.error(`${error.response.data.message}`, {
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
                
            } else {
                toast.error('Kritik dan Saran Tidak Berhasil Dikirim', {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        });
    }

    return (
        <div>
            <ToastContainer
                position="bottom-left"
                autoClose={5000}
                toastStyle={{ backgroundColor: "#000", color: "#FFF", fontWeight: "bold" }}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <h1 className='mb-1'>Kritik dan Saran</h1>
            <p>Untuk alasan tertentu Anda tidak puas dengan layanan kami, Anda dapat menyampaikan kritik dan saran pada form dibawah</p>
            <form onSubmit={handleSubmit(submitKritikSaran)}>
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <label>Nama Lengkap</label>
                        <input type="text" {...register("nama_lengkap")} className='form-control'></input>
                    </div>
                    <div className="col-md-12 mb-4">
                        <label>Email</label>
                        <input type="email" {...register("email_aktif")} className='form-control'></input>
                    </div>
                    <div className="col-md-12 mb-4">
                        <label>Nomor Telepon</label>
                        <input type="tel" {...register("no_telepon")} className='form-control'></input>
                    </div>
                    <div className="col-md-12 mb-4">
                        <label>Topik</label>
                        <textarea type="text" {...register("topik")} rows={3} className='form-control'></textarea>
                    </div>
                    <div className="col-md-12 mb-4">
                        <label>Isi</label>
                        <textarea type="text" {...register("isi")} rows={10} className='form-control'></textarea>
                    </div>
                    <div className="col-md-12">
                        <button type='submit' className='btn btn-success'>Ajukan Kritik dan Saran</button>
                    </div>
                </div>
            </form>
        </div>
    )
};